import { useEffect, useState } from 'preact/hooks';
import { getTheme, toggleTheme, type Theme } from '../lib/theme';

export function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>('light');

  useEffect(() => {
    setTheme(getTheme());
  }, []);

  const onClick = () => {
    toggleTheme();
    setTheme(getTheme());
  };

  const isDark = theme === 'dark';

  return (
    <button
      onClick={onClick}
      aria-label="Toggle theme"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        padding: '8px 14px 8px 10px',
        borderRadius: 999,
        border: 'none',
        cursor: 'pointer',
        background: 'var(--surface)',
        color: 'var(--ink)',
        boxShadow: 'var(--shadow-card)',
        fontFamily: 'var(--font-ui)',
        fontWeight: 600,
        fontSize: 13,
        letterSpacing: 0.4,
        transition: 'transform 120ms ease',
      }}
    >
      <span
        style={{
          width: 22,
          height: 22,
          borderRadius: 11,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: isDark ? 'var(--gradient)' : 'var(--ink)',
          color: isDark ? 'var(--ink)' : 'var(--marigold)',
          fontSize: 13,
          lineHeight: 1,
        }}
      >
        {isDark ? '☀' : '☾'}
      </span>
      {isDark ? 'Light' : 'Dark'}
    </button>
  );
}
